var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images-container"},_vm._l((_vm.images),function(image){return _c('div',{key:image.url,staticClass:"image"},[_c(image.profile ? 'router-link' : 'span',{tag:"router-link",staticClass:"undecorated-router-link",attrs:{"to":{
        name: 'student-community-profile-view',
        params: { id: image.profile },
      },"target":"_blank"}},[_c('HMImageIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content: image.tooltip,
          delay: 100,
          placement: 'top',
          container: 'body',
        }),expression:"{\n          content: image.tooltip,\n          delay: 100,\n          placement: 'top',\n          container: 'body',\n        }"}],attrs:{"image":image,"size":_vm.size,"title":image.title}})],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }